import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import TablePagination from "@material-ui/core/TablePagination";

import TableActions from "./TableActions";

const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.darker,
    backgroundColor: "white",
    borderRadius: "20px",
    fontSize: "1.6rem",
  },

  select: {
    height: "auto",
    fontSize: "1.6rem",
  },
}));

const CustomTablePagination = props => {
  const classes = useStyles();
  return (
    <TablePagination
      {...props}
      classes={{ root: classes.root }}
      SelectProps={{ native: true, classes: { root: classes.select } }}
      ActionsComponent={TableActions}
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
    />
  );
};

export default CustomTablePagination;
